/**
 *
 * ClassRestrictionMixin.mixin
 *
 */

import { mapState, mapActions } from 'vuex';
//import _ from 'lodash';
import Swal from 'sweetalert2';

export const ClassRestrictionMixin = {
  name: 'ClassRestrictionMixin',

  data: () => {
    return {
      promiseClassRestrictionCoursePageInfo: null,

      isNeedRestrictStudentVideo: true,
      isNeedRestrictStudentFile: true,

      promiseGetClassRestriction: null,
    };
  },

  computed: {
    ...mapState('Mixins/ClassRestriction', {
      ms_classRestriction: 'classRestriction',
    }),

    c_isClassRestrictionCoursePage() {
      return null !== this.promiseGetClassRestriction;
    },

    //
    c_courseId() {
      //return -1;
    },

    //
    c_restrictStudent() {
      //return false;
    },

    c_isRestrictionOpenPlayerCount_0() {
      return 0 === this.ms_classRestriction.videoCount;
    },

    c_isRestrictionOpenPlayerDisabled() {
      if (this.c_restrictStudent) {
        return this.c_isRestrictionOpenPlayerCount_0 || this.isNeedRestrictStudentVideo;
      } else {
        return false;
      }
    },

    c_isRestrictionDownloadMaterialCount_0() {
      return 0 === this.ms_classRestriction.resourceCenterDownloadCount;
    },

    c_isRestrictionDownloadMaterialDisabled() {
      if (this.c_restrictStudent) {
        return this.c_isRestrictionDownloadMaterialCount_0 || this.isNeedRestrictStudentFile;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions('Mixins/ClassRestriction', {
      ma_getClassRestriction: 'getClassRestriction',
    }),

    async getClassRestriction() {
      this.promiseGetClassRestriction = this.ma_getClassRestriction({
        courseId: this.c_courseId,
      });
      await this.promiseGetClassRestriction;
    },

    checkClassRestrictionAndOpenPlayer(openPlayer) {
      if (typeof openPlayer != 'function') {
        return openPlayer;
      }
      return async (...args) => {
        if (this.c_isClassRestrictionCoursePage) {
          await this.promiseClassRestrictionCoursePageInfo;
        }
        if (this.c_restrictStudent) {
          await this.getClassRestriction();
          if (this.c_isRestrictionOpenPlayerDisabled) {
            await Swal.fire({
              width: '400px',
              icon: 'info',
              title: '温馨提示',
              text: this.ms_classRestriction.videoCountMessage,
              showConfirmButton: true,
              confirmButtonText: !this.c_isRestrictionOpenPlayerCount_0 ? '继续' : '确定',
              showCancelButton: !this.c_isRestrictionOpenPlayerCount_0,
              cancelButtonText: '取消',
            }).then((result) => {
              if (!this.c_isRestrictionOpenPlayerCount_0 && this.isNeedRestrictStudentVideo) {
                this.isNeedRestrictStudentVideo = !result.value;
              }
            });
          }
        }
        if (!this.c_isRestrictionOpenPlayerDisabled) {
          openPlayer(...args);
        }
      };
    },

    checkClassRestrictionAndDownloadMaterial(downloadMaterial) {
      if (typeof downloadMaterial != 'function') {
        return downloadMaterial;
      }
      return async (...args) => {
        if (this.c_isClassRestrictionCoursePage) {
          await this.promiseClassRestrictionCoursePageInfo;
        }
        if (this.c_restrictStudent) {
          await this.getClassRestriction();
          if (this.c_isRestrictionDownloadMaterialDisabled) {
            await Swal.fire({
              width: '400px',
              icon: 'info',
              title: '温馨提示',
              text: `${this.ms_classRestriction.downloadCountMessage}`,
              confirmButtonText: !this.c_isRestrictionDownloadMaterialCount_0 ? '继续' : '确定',
              showCancelButton: !this.c_isRestrictionDownloadMaterialCount_0,
            }).then(async (result) => {
              if (!this.c_isRestrictionDownloadMaterialCount_0 && this.isNeedRestrictStudentFile) {
                this.isNeedRestrictStudentFile = !result.value;
              }
            });
          }
        }
        if (!this.c_isRestrictionDownloadMaterialDisabled) {
          downloadMaterial(...args);
        }
      };
    },

    checkClassRestrictionAndDoFunc(func) {
      if (typeof func != 'function') {
        return func;
      }
      return async (...args) => {
        if (this.c_isClassRestrictionCoursePage) {
          await this.promiseClassRestrictionCoursePageInfo;
        }
        if (this.c_restrictStudent) {
          if (null === this.promiseGetClassRestriction) {
            await this.getClassRestriction();
          }
          Swal.fire({
            width: '400px',
            icon: 'info',
            title: '温馨提示',
            text: this.ms_classRestriction.restrictedMessage,
            showConfirmButton: true,
            confirmButtonText: '确定',
          });
        } else {
          func(...args);
        }
      };
    },

    setPromiseGetClassRestriction() {
      //
    },
  },

  created() {
    this.openPlayer = this.checkClassRestrictionAndOpenPlayer(this.openPlayer);
    this.downloadMaterial = this.checkClassRestrictionAndDownloadMaterial(this.downloadMaterial);
    setTimeout(this.setPromiseGetClassRestriction, 0);
  },
};

export default ClassRestrictionMixin;
